module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3dfc8d5cdedb3e5e2a737e346bab51f8.png";